import styled from 'styled-components'

import CheckedStar from 'src/Assets/Svg/rateStars/checkedStar.svg?react'
import UncheckedStar from 'src/Assets/Svg/rateStars/uncheckedStar.svg?react'

const StyledCheckedStar = styled(CheckedStar)`
  color: ${({ theme }) => theme.color.mediumOrange};
`

const StyledUncheckedStar = styled(UncheckedStar)`
  color: ${({ theme }) => theme.color.mediumGrey};
`

export const getStarIcon = (index: number, value: number): JSX.Element =>
  index < value ? (
    <StyledCheckedStar width={16} height={16} />
  ) : (
    <StyledUncheckedStar width={16} height={16} />
  )
